import React from 'react';
import './book-detail.css';

export default function BookDetail({
  image,
  title,
  author,
  evaluation,
  edition,
  readingTime,
  description,
  availableEpubFormat,
  availablePdfFormat,
  availableAudioFormat,
  availableComposerFormat,
  authenticatedUser,
  userEvaluation,
  isFavorite,
  onClickReadEpub,
  onClickReadPdf,
  onClickOpenComposer,
  onClickOpenAudiobook,
  onClickEvaluation,
  onClickFavorite,
  onClickAddToReadingList,
  onClickSummary
}) {
  const rating = evaluation ? Number(evaluation).toFixed(1) : '0.0';

  return (
    <div className="rdp-book-detail">
      <div className="rdp-react-template-view-search-term-breadcrumb" style={{
        marginTop: "0px",
        marginBottom: "40px"
      }}>
        <button className="rdp-react-template-view-search-term-breadcrumb-item" onClick={() => {
          window.location = window.location.origin + window.location.pathname + "#" + "/";
        }}>
          <div className="rdp-react-template-view-search-term-breadcrumb-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path fill="#084c8a" d="M25.16,13.82L15.59,5.51c-.34-.29-.84-.29-1.18,0L4.84,13.83c-.37.32-.41.89-.09,1.26.17.19.41.31.67.31h2.37v8.41c0,.49.4.9.9.9h3.38c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-5.93h3.95v5.93c0,.49.4.9.9.9h3.33c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-8.41h2.53c.49,0,.9-.4.9-.9,0-.26-.11-.51-.31-.68ZM22.01,14.46c-.49,0-.9.4-.9.9v8.41h-3.26v-5.93c0-.5-.4-.9-.9-.9,0,0,0,0,0,0h-4.02c-.49,0-.9.4-.9.9v5.93h-3.3v-8.41c0-.49-.4-.9-.9-.9h-2.31L15,6.23l9.48,8.23h-2.47Z"></path></svg>
          </div>
          <span className="rdp-react-template-view-search-term-breadcrumb-item-label">Biblioteca</span>
        </button>
        <span className="rdp-react-template-view-search-term-breadcrumb-chevron"></span>
        <span className="rdp-react-template-view-search-term-breadcrumb-category">Detalhes do Livro</span>
        {window.innerWidth > 768 && (
          <>
            <span className="rdp-react-template-view-search-term-breadcrumb-chevron"></span>
            <span className="rdp-react-template-view-search-term-breadcrumb-category">{title}</span>
          </>          
        )
        }
        {console.log(window.innerWidth)}
      </div>

      <div className="rdp-book-detail-container">
        <div className="rdp-book-detail-image">
          <img src={image} alt={title} />
        </div>
        
        <div className="rdp-book-detail-info">
          <h1 className="rdp-book-detail-title">{title}</h1>
          <h2 className="rdp-book-detail-author">{author}</h2>
          
          {edition && (
            <p className="rdp-book-detail-edition">
              {edition.includes('edição') ? edition : `${edition}ª edição`}
            </p>
          )}
          
          <div className="rdp-book-detail-rating">
            {authenticatedUser && !userEvaluation ? (
              <div className="rdp-book-detail-rating-action" onClick={onClickEvaluation}>
                <span className="rdp-book-detail-star">★</span>
                <span>Avaliar | {readingTime} de leitura</span>
              </div>
            ) : (
              <div className="rdp-book-detail-rating-display">
                <div style={{ cursor: 'pointer' }} onClick={onClickEvaluation}>
                    <span className="rdp-book-detail-star" >★</span>
                    <span>{rating} | </span>
                </div>
                <span>{readingTime} de leitura</span>
              </div>
            )}
          </div>
          
          <div className="rdp-book-detail-actions">
            {!authenticatedUser && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-sample"
                onClick={availableEpubFormat ? onClickReadEpub : onClickReadPdf}
              >
                Ler amostra
              </button>
            )}
            
            {authenticatedUser && availableEpubFormat && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-epub"
                onClick={onClickReadEpub}
              >
                Ler ePub
              </button>
            )}
            
            {authenticatedUser && availablePdfFormat && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-pdf"
                onClick={onClickReadPdf}
              >
                Ler PDF
              </button>
            )}

            {authenticatedUser && availableComposerFormat && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-composer"
                onClick={onClickOpenComposer}
              >
                Visualizar conteúdo
              </button>
            )}
            
            {authenticatedUser && availableAudioFormat && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-audio"
                onClick={onClickOpenAudiobook}
              >
                ▶ Ouvir Audiobook
              </button>
            )}
            
            {authenticatedUser && (
              <button 
                className={`rdp-book-detail-btn rdp-book-detail-btn-favorite ${isFavorite ? 'active' : ''}`}
                onClick={onClickFavorite}
              >
                Favorito
              </button>
            )}
            
            {authenticatedUser && onClickSummary && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-summary"
                onClick={onClickSummary}
              >
                Sumário
              </button>
            )}
            
            {authenticatedUser && onClickAddToReadingList && (
              <button 
                className="rdp-book-detail-btn rdp-book-detail-btn-reading-list"
                onClick={onClickAddToReadingList}
              >
                Adicionar à Lista
              </button>
            )}
          </div>
        </div>
      </div>
      
      {description && (
        <div className="rdp-book-detail-description">
          <h3>Sobre este Livro</h3>
          <p>{description}</p>
        </div>
      )}
    </div>
  );
}